import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { toggleDensity, setDensity } from '@/redux/slices/uiSlice'
import { useEffect } from 'react'

export function useDensity() {
  const dispatch = useAppDispatch()
  const density = useAppSelector((state) => state.ui.density)

  const toggle = () => dispatch(toggleDensity())
  const set = (d: 'comfortable' | 'compact') => dispatch(setDensity(d))

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-density', density)
    }
  }, [density])

  return {
    value: density,
    toggle,
    set
  }
}
